import {reactive} from 'vue'

export const config = reactive({
  siteName: 'Rifen',
  logo: '/img/logo-white.png',
  language: 'en-US',
  developmentMode: false
})
